<section class="access" *ngIf="!reportsAccess || schoolsNotFound">
  <p class="access-text" *ngIf="!reportsAccess">У вас нет доступа, обратитесь к администратору, <br>чтобы он выдал вам доступ.</p>
  <p class="access-text" *ngIf="schoolsNotFound">У вас нет доступных школ, обратитесь к администратору, <br>чтобы он выдал вам доступ.</p>
</section>

<section class="reports" *ngIf="schools.length > 0">
  <h4 class="title">Сборка и отправка данных в виде csv файла</h4>
  <small>После отправки запроса, будет проводиться сборка данных
  <br>и после того как данные будут собранны файл с данными будет отправлен
  <br> на указанную почту</small>

  <div class="reports-form">
    <form [formGroup]="reportsForm" (ngSubmit)="onSubmit()">
      <div class="reports-type">
        <mat-label>Выберите тип отчета по студентам</mat-label>
        <mat-radio-group class="reports-type-radio" aria-label="Выберите тип отчета по студентам" formControlName="reportsType">
          <mat-radio-button value="1">Сумарная аналитика</mat-radio-button>
          <mat-radio-button value="2">Отчет по звездачкам</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="dates-form">
        <small>Укажите даты по которым классы входящие в данный диапазон
          <br>будут включены в отчет</small>
        <div class="dates">
          <mat-form-field appearance="outline" class="date-element">
            <mat-label>дата от</mat-label>
            <input matInput [matDatepicker]="startLearn" formControlName="startLearnDate">
            <mat-datepicker-toggle matSuffix [for]="startLearn"></mat-datepicker-toggle>
            <mat-datepicker #startLearn></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="date-element">
            <mat-label>дата до</mat-label>
            <input matInput [matDatepicker]="endLearn" formControlName="endLearnDate">
            <mat-datepicker-toggle matSuffix [for]="endLearn"></mat-datepicker-toggle>
            <mat-datepicker #endLearn></mat-datepicker>
          </mat-form-field>
        </div>
      </div>


      <mat-form-field appearance="outline" *ngIf="schools.length > 0">
        <mat-label>Выберите школу</mat-label>
        <mat-select formControlName="schoolId">
          <mat-option *ngFor="let school of schools" [value]="school.id">{{ school.title }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="reports-form-email" hintLabel="* Обязательно. Пример формата example@mail.ru" appearance="outline">
        <mat-label><mat-icon>mail</mat-icon> Email</mat-label>
        <input matInput #email placeholder="your email" formControlName="email">
        <mat-error *ngIf="reportsForm.controls.email.invalid">* Обязательное поле. Пример формата example@mail.ru</mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        [disabled]="!reportsForm.valid">Отправить запрос</button>
    </form>
  </div>

</section>